import { useEffect } from 'react';
import { useQueryClient } from 'react-query';
import { Channels } from '../utils/channels';
import { queryKeys } from './queryKeyFactory';

export default (): void => {
  const queryClient = useQueryClient();

  useEffect(() => {
    Channels.initialize();

    subscribeToMessages();

    return () => Channels.close();
  }, []);

  const subscribeToMessages = () => {
    Channels.savedSearchesChannel.onmessage = () => {
      queryClient.invalidateQueries([queryKeys.savedSearches.all]);
    };

    Channels.recentSearchesChannel.onmessage = () => {
      queryClient.invalidateQueries([queryKeys.recentSearches.all]);
    };
  };
};
